import './userFormUpdate.scss';
import {useState} from 'react';
import {Modal, ButtonToolbar, Button, RadioGroup, Radio, Placeholder} from 'rsuite';
import AuthService from "../../../../services/auth.service";

const UserFormUpdate = (props) => {
    if (!AuthService.getSubscription()) {
        return <></>
    }

    if (AuthService.getSubscription().is_user_form_update) {
        return <></>
    }

    //window.location.replace('/weighing')
    return false;

    const subscription = AuthService.getSubscription();
    const {modal} = subscription;

    return <div className="user-form-update">
        <Modal backdrop={true} keyboard={false} open={true} className="user-form-update">
            <Modal.Header closeButton={false}>

            </Modal.Header>

            <Modal.Body>
                <img src={modal.featured_image}/>

                <div className="title">
                    {modal.title}
                </div>

                <div className="body">
                    {modal.body}
                </div>
            </Modal.Body>
            <Modal.Footer>
                <div className="buttons-container">
                    {modal.buttons.map((button, buttonIndex) => {
                        return <Button appearance="primary" block={true}
                                       onClick={event => {
                                           if (button.action === 'intent') {
                                               window.location.href = button.data;
                                           }
                                       }}
                                       key={buttonIndex}>
                            {button.text}
                        </Button>
                    })}
                </div>
            </Modal.Footer>
        </Modal>
    </div>;

    function handleOnClick(event) {

    }
}

export default UserFormUpdate;